<div class="col-md-12 mb-30">
  <div class="card card-statistics h-100">
    <div class="card-body">
      <h5 class="card-title border-0 pb-0">تصدیق برچسب گواهی نامه </h5>
      <br />

      <br>
      <br>
      <div class="row">

        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">شماره نامه</label>
          <input [(ngModel)]="Filter_Letter_Id" 
            name="Filter_Letter_Id" type="number" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
        <div class="form-group col-md-4">
          <label for="exampleInputEmail1">نام مشتری</label>
          <input [(ngModel)]="Filter_Customer"
            name="Filter_Customer" type="text" class="form-control"
            placeholder="برای جستجوی ، اینجا تایپ کنید ...">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-12">
          <button type="button" (click)="ReadData_Certificate()" class="btn btn-info" style="margin-left: 5px;"><i
              class="fa  fa-search"></i> جستجوی اطلاعات </button>

        <button *ngIf="!Procssing" (click)="openModal(templateOperationList,1,0)" type="button" class="btn btn-success"
        style="margin-left: 5px;"><i class="fa fa-plus-circle"></i> تایید </button>

          <img *ngIf="Procssing" src="assets/Loading.gif" style="width: 25px;" />
        </div>

      </div>

      <br>
      <br>

      <div class="table-responsive">
        <table class="mb-0 table table-bordered table-3 text-center table-striped">
          <thead style="background-color: #489b39; color: white;">
            <tr>
              <th>
                <input type="checkbox" [checked]="Check_All" (click)="onChange_CheckAll()" />
              </th>
              <th>#</th>
              <th>شناسه رسید</th>
              <th>نام مشتری</th>
              <th>کد تجهیز</th>
              <th>سریال تجهیز</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of DataList_Certificate
            | paginate
                    : {
                        id: 'DataList_CertificateTable',
                        itemsPerPage: 20,
                        currentPage: page,
                        totalItems: (DataList_Certificate).length
                      }
            " [ngClass]="{'alarm': item.alarm===1}">
              <td>
                <input type="checkbox"  [checked]="item.selected"
                  (click)="onChange_CheckItem(item)" />
              </td>
              <td>{{DataList_Certificate.indexOf(item)+1}}</td>
              <td>{{item['code2']}}</td>
              <td>{{item['customerName']}}</td>
              <td>{{item['code']}}</td>
              <td>{{item['serial']}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <pagination-controls id="DataList_CertificateTable" nextLabel="بعدی" previousLabel="قبلی"
      (pageChange)="page = $event"></pagination-controls>
  </div>
</div>


<ng-template #templateOperationList>
  <div class="modal-header">
    <h4 class="modal-title pull-left"> تایید </h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalRef_operation.hide()">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-footer">
    <img *ngIf="InProccessing" src="assets/Loading.gif" style="width: 25px;" />
    <button (click)="ConfirmList()" type="button" class="btn btn-success" style="margin-left: 5px;"><i
        class="fa  fa-plus-circle"></i> تایید </button>
    <button type="button" class="btn btn-danger" (click)="modalRef_operation.hide()">بستن</button>
  </div>
</ng-template>